module.exports = __webpack_public_path__ + "img/visa.db19b0ae.png";